import { render, staticRenderFns } from "./AthletePending.vue?vue&type=template&id=42ecf4ec&"
import script from "./AthletePending.vue?vue&type=script&lang=js&"
export * from "./AthletePending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports